module.exports = __webpack_public_path__ + "static/media/RADWAN NUAIMI.9e5b9f47.png";